export default __webpack_public_path__ + "static/media/property-bg-image.0d7549ac.svg";